import { render } from "./UserManageList.vue?vue&type=template&id=130bfefc&ts=true"
import script from "./UserManageList.vue?vue&type=script&lang=ts"
export * from "./UserManageList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__